export enum LoadingStatus {
  prepareFile = 'prepareFile',
  saveChanges = 'saveChanges'
}
